import { IOptionSelect } from "src/@types/form";

export const BUTTONS: IOptionSelect[] = [
  {
    id: 1,
    value: "individual-entrepreneur",
    label: "Фізична особа-підприємець",
  },
  {
    id: 2,
    value: "legal-entity",
    label: "Юридична особа",
  },
];
